























































































import { Vue, Component } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';
import YearDropdown from './YearDropdown.vue';
import ParsingModal from './ParsingModal.vue';


interface Obl {
    code: string;
    obl: string;
    region: string;
}

interface IFormHeader {
    key: string;
    label: string | TranslateResult;
}

interface ILog {
    user_id: string;
    log_id?: string; 
    user_name: string; 
    snp_count: number | null;
    log_status: string;
    is_download: boolean;
    created_at: string;
}

@Component({
    components: {
        YearDropdown,
        ParsingModal
    }
})
export default class SrsParsing extends Vue {
    obl: Obl = {code: '', obl: '', region: ''};
    logs: ILog[] = [];
    selectedYear: number = new Date().getFullYear(); 
     

    async mounted() {
        await this.getObl(); 
        await this.fetchLogs(this.selectedYear);
    }

    get formHeaders(): IFormHeader[] {
        return [
            { key: "id", label: "ID" },
            { key: "datetime", label: this.$t('modules.srs.parsing.datetime') as TranslateResult },
            { key: "snp", label: this.$t('modules.srs.parsing.snp-count') as TranslateResult },
            { key: "user", label: this.$t('modules.srs.parsing.user') as TranslateResult },
            { key: "status", label: this.$t('modules.srs.parsing.status') as TranslateResult },
            { key: "download", label: this.$t('modules.srs.parsing.download') as TranslateResult },
        ];
    }

    onYearChange(year: number) {
        this.selectedYear = year;
        this.fetchLogs(year);
    }

    handleErrorLogDownload(logId: string) {
        this.fetchLogById(logId);
    }

    async fetchLogById(logId: string) {
        try {
            const response = await fetch(
                `/api-py/srs/data-upload/parsing/logs/${logId}?lang=${this.getNormalizedLocale()}`
            ); 
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`)
            }

            const fileName = this.$t('modules.srs.parsing.error-log') as TranslateResult;
            const formattedDate = new Date().toLocaleDateString('en-CA');
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${fileName}-${formattedDate}.xlsx`;
            link.style.display = 'none';
            link.click();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            const err = error as Error;
            console.error(err);
        }
    }
    
    async fetchLogs(year: number) {
        try {
            const response = await fetch(
                `/api-py/srs/data-upload/parsing/logs/?year=${year}`
            ); 
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`)
            }
            this.logs = await response.json();
        } catch (error) {
            const err = error as Error;
            console.error(err);
        }
    }

    async handleStartParsing(formData: FormData) {
        try {
            this.makeToast(
                'warning',
                String(this.$t('modules.srs.parsing.parsing-started')),
                String(this.$t('modules.srs.warnings.information'))
            );

            this.logs.unshift({
                log_id: '',
                user_id: formData.get('userId') as string,
                user_name: formData.get('userName') as string,
                snp_count: null,
                log_status: 'IN_PROGRESS',
                is_download: false,
                created_at: '',
            }); 
            const lang = this.getNormalizedLocale();
            const response = await fetch(`/api-py/srs/data-upload/parsing/${this.obl.code}?lang=${lang}`, {
                method: 'POST',
                body: formData,
            })

            if (!response.ok) {
                throw new Error(`HTTP ${response.status}`)
            }
            const newLog = await response.json()
            this.$set(this.logs, 0, newLog) 
            this.makeToast(
                'success',
                String(this.$t('modules.srs.parsing.parsing-completed')),
                String(this.$t('modules.srs.warnings.information'))
            )
             
        } catch (err) {
            const errorLog = {
                user_id: formData.get('userId') as string,
                user_name: formData.get('userName') as string,
                snp_count: null,
                log_status: 'ERROR',
                created_at: '',
            }

            this.$set(this.logs, this.logs.length - 1, errorLog)
            console.error(err)
        }
    }

    getNormalizedLocale(locale=this.$i18n.locale): string {
        return (locale === 'kk' || locale === 'kz') ? 'kz' : locale;
    }

    async getObl(): Promise<void> {
        try {
            const response = await fetch(`/api-py/get-budget-obl/${this.$store.state._instanceCode}`)
            this.obl = await response.json();
        } catch (error) {
            const err = error as Error;
            this.makeToast(
                'danger',
                String(this.$t('modules.srs.warnings.get_obl_error')),
                err.message || err.toString()
            );
        }
    }

    makeToast(variant: string, tostbody: string, title: string, autoHideDelay?: number): void {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            autoHideDelay: autoHideDelay || 3500,
            solid: true
        });
    }
}
